///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, Input, OnInit } from '@angular/core';
import { SuiEditableSelectControlComponent, SuiEditableSelectOption, SuiTypeNumber } from '@siklu/sui-lib/infrastructure';
import { isDefined } from '@siklu/sui-lib/utils';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

// This control should be used only within projects
@Component({
    selector: 'winde-sui-project-editable-select-component',
    templateUrl: 'sui-project-editable-select.component.html',
    styleUrls: ['./sui-project-editable-select.scss'],
    imports: [FormsModule, NgClass]
})
export class SuiProjectEditableSelectComponent extends SuiEditableSelectControlComponent<number> implements OnInit {
    @Input() public readonly = false;
    public isOpen = false;

    public selectedOption: SuiEditableSelectOption<number>;

    ngOnInit(): void {
        this.selectedOption = this.config.findSelectedOption();
    }

    toggleOpen() {
        this.isOpen = !this.isOpen;
    }

    selectOption(option: SuiEditableSelectOption<number>): void {
        this.isOpen = false;
        this.selectedOption = option;
        this.config.setValue(option?.editType ? option.editType.value : option.value);
        this.valueChanged.emit(this.config.value);
    }

    isOptionActive(optionKey: SuiEditableSelectOption<number>) {
        return this.selectedOption === optionKey;
    }

    setValue(value: number) {
        if (isDefined(value) && this.selectedOption?.editType) {
            if (value > this.getMax(this.selectedOption)) {
                value = this.getMax(this.selectedOption);
            }
            if (value < this.getMin(this.selectedOption)) {
                value = this.getMin(this.selectedOption);
            }
        }

        this.config.setValue(value);
        this.valueChanged.emit(this.config.value);
    }

    getSelectedOption(): string {
        return this.selectedOption?.editType ? this.selectedOption.value + '' : this.selectedOption.text;
    }

    getMin(selectedOption: SuiEditableSelectOption<number>) {
        return (selectedOption.editType as SuiTypeNumber).min;
    }

    getMax(selectedOption: SuiEditableSelectOption<number>) {
        return (selectedOption.editType as SuiTypeNumber).max;
    }
}
